/* eslint-disable
    no-restricted-syntax,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.factory('Chart', (Contract, moment, $state, $rootScope, $filter) => {
    // For the colors of the charts you have to take into account the 75% of opacity
    // applied by d3. See http://stackoverflow.com/questions/12228548/finding-equivalent-color-with-opacity
    // for conversion formulas.
    let info = []

    const setScale = (data) =>
        [
            0,
            _(data)
            .values()
            .flatten()
            .map('values')
            .flatten()
            .map('y')
            .max(),
        ]



    const watch = {
        data(callback) {
            return $rootScope.$on('chart-updated', (event, chart) => callback(chart))
        },
        activeIndex(callback) {
            return $rootScope.$on('chart-active-index-updated', (event, index) => callback(index))
        },
    }

    const retrieveFilteredData = (values, tempclass) => values.filter((value) => value.temp_class === tempclass)


    const sortData = (values) =>
        values.sort((value1, value2) => {
            if (value1.year === value2.year) {
                return (+(value1.month > value2.month) * 2) - 1
            }
            return (+(value1.year > value2.year) * 2) - 1
        })


    const trimData = function (values, limit) {
        values.splice(0, values.length - limit)
        return values
    }

    const fillData = function (values, limit) {
        while (values.length < limit) {
            values.push({
                month: values[values.length - 1].month + 1,
                year: values[values.length - 1].year,
            })
        }
        return values
    }

    const formatEstimatedData = (values, type) =>
        values.map((value) => {
            let estimated
            const date = moment().year(+value.year).month(+value.month - 1)
            if (value.correctedCons) {
                estimated = value.correctedCons
            } else if (value.estimatedCons) {
                estimated = value.estimatedCons
            } else {
                estimated = 0
            }
            return {
                x: date.format('MMM YY'),
                y: +estimated,
                type,
            } })


    const formatRealData = (values, type) =>
        values.map((value) => {
            let real
            const date = moment().year(+value.year).month(+value.month - 1)
            if (value.realCons) {
                real = value.realCons
            } else if (value.autoCons) {
                real = value.autoCons
            } else {
                real = 0
            }
            return {
                x: date.format('MMM YY'),
                y: +real,
                type,
            } })


    const getActiveIndex = function () {
        for (const value of Array.from(info)) {
            if (value.active) {
                return info.indexOf(value)
            }
        }
    }

    const paintActive = function () {
        const activeIndex = getActiveIndex()
        if (activeIndex !== undefined) {
            $rootScope.$emit('chart-active-index-updated', activeIndex)
            return d3.selectAll(`.nv-bar:nth-child(${activeIndex + 1})`)
            .classed({ 'nv-bar-active': true })
        }
    }

    const makeActive = function (index) {
        const activeIndex = getActiveIndex()
        if (activeIndex !== undefined) {
            info[activeIndex].active = false
            d3.selectAll(`.nv-bar:nth-child(${activeIndex + 1})`)
            .classed({ 'nv-bar-active': false })
        }
        info[index].active = true
        return paintActive()
    }

    const formatInfoData = function (val, userIsBase) {
        let values
        let valuesHC
        if (!userIsBase) {
            valuesHC = retrieveFilteredData(val, 'HC')
            valuesHC = trimData(valuesHC, 12)
            valuesHC = fillData(valuesHC, 12)
            values = retrieveFilteredData(val, 'HP')
        }
        // Sort the values chronologically
        values = sortData(values)
        // Remove or add values
        values = trimData(values, 12)
        values = fillData(values, 12)
        info = values.map((value) => {
            let consumption
            let estimatedCons
            let paid
            const date = moment().year(+value.year).month(+value.month - 1)
            const pot = {
                type: null,
                value: 'En attente',
            }
            if (value.earnedPot) {
                pot.type = 'earned'
                pot.value = $filter('frAmount')((+value.earnedPot))
            } else if (value.estimatedEarnedPot) {
                pot.type = 'estimated'
                pot.value = $filter('frAmount')((+value.estimatedEarnedPot))
            } else if (date.isBefore(moment())) {
                pot.type = 'unknown'
            }
            if (userIsBase) {
                consumption = +value.estimatedConsValued
                estimatedCons =
          { base: +value.estimatedCons }
            } else {
                const monthHC = valuesHC.filter((valueHC) => (valueHC.month === value.month) && (valueHC.year === value.year))
                consumption = +value.estimatedConsValued + +monthHC[0].estimatedConsValued
                estimatedCons = {
                    hp: +value.estimatedCons,
                    hc: +monthHC[0].estimatedCons,
                }
            }
            if (value.estimatedAmount !== undefined) {
                paid = $filter('frAmount')((+value.taxes + +value.subscription + consumption))
            } else {
                paid = 'En attente'
            }
            return {
                active: moment().month() === (+value.month - 1),
                consumption: $filter('frAmount')(consumption),
                date,
                mensuality: date.format('MMMM YYYY'),
                paid,
                pot,
                subscription: $filter('frAmount')((+value.subscription)),
                taxes: $filter('frAmount')((+value.taxes)),
                estimatedCons,
            } })
        return info
    }

    const formatData = function (val, key) {
        let values
        const data = [
            {
                key: 'Estimé',
                values: [],
                color: '#93a3b7',
            },
            {
                key: 'Consommé',
                values: [],
                color: '#071B37',
            },
        ]
        if (key !== 'base') {
            values = retrieveFilteredData(val, key)
        }
        // Sort the values chronologically
        values = sortData(values)
        // Remove or add values
        values = trimData(values, 12)
        values = fillData(values, 12)
        data[0].values = formatEstimatedData(values, key)
        data[1].values = formatRealData(values, key)
        return data
    }

    const options = {
        multiBarChart: {
            chart: {
                type: 'multiBarChart',
                height: 200,
                margin: {
                    top: 20,
                    right: 0,
                    bottom: 15,
                    left: 0,
                },
                clipEdge: true,
                groupSpacing: 0.3,
                duration: 500,
                stacked: false,
                showControls: false,
                showYAxis: false,
                showXAxis: false,
                showLegend: false,
                noData: 'Aucune donnée disponible.',
                multibar: {
                    dispatch: {
                        renderEnd(e) {
                            if ($state.current.name === 'tracking') {
                                // for after window resize
                                d3.selectAll('rect.nv-bar')
                                .attr('stroke-width', 0)
                                .attr('rx', 2)
                                .style('fill', '')
                                return paintActive()
                            }
                        },
                        elementClick(element) {
                            return makeActive(element.index)
                        },
                    },
                },
                useInteractiveGuideline: false,
                tooltip: {
                    contentGenerator(data) {
                        const type = {
                            base: '',
                            HP: ' en HP',
                            HC: ' en HC',
                        }[data.data.type]
                        let content = `<div class='tooltip-header'>${data.value}</div>`
                        data.series.forEach((serie) => {
                            if (serie.value) {
                                content += '<i class=\'fa fa-circle\' style=\'color: '
                                content += `${serie.color}'></i> ${serie.key}${type} : `
                                content += `${serie.value} kWh`
                                return content
                            }
                        })
                        return content
                    },
                    distance: 30,
                    gravity: 's',
                },
                callback() {
                    d3.selectAll('rect.nv-bar')
                    .attr('stroke-width', 0)
                    .attr('rx', 2)
                    .style('fill', '')
                    return paintActive()
                },
            },
        },
    }

    return {
        options,
        watch,
        setScale,
        utils: {
            makeActive,
            sortData,
            trimData,
            fillData,
            retrieveFilteredData,
            formatData,
            formatInfoData,
        },
    }
})
